import {
	TRIGGER_FETCH_MATCH_DETAILS_API,
	TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS,
	TRIGGER_CLEAR_MATCH_DETAILS,
} from 'redux/actionTypes';

export function triggerFetchMatchDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_MATCH_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchMatchDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_MATCH_DETAILS_API_SUCCESS,
		data,
	};
}

export function triggerClearMatchDetails(data) {
	return {
		type: TRIGGER_CLEAR_MATCH_DETAILS,
		data,
	};
}
